import { h } from 'preact'
import * as firebase from 'firebase'
import FirebaseComponent from './FirebaseComponent'
import Landing from './Landing'
import Dashboard from './Dashboard'

class Home extends FirebaseComponent {
  constructor() {
		super()
    this.homeBody = this.homeBody.bind(this)
  }

  homeBody() {
    if (firebase.auth().currentUser != null) {
      return <Dashboard />
    } else {
      return <Landing />
    }
  }

  render() {
    return this.homeBody()
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/Home.js